import axios from "axios";
import {StripeIntentData} from "../model/StripeIntentData";

export class StripeUtils{

    public static async retrieveClientSecret(app: any, amountToPay: any): Promise<StripeIntentData>{
        let response = await this.makePaymentIntentRequest(app, amountToPay);
        if(response !== null){
            if (response !== undefined && response.data !== undefined && response.data.processed) {
                if (response.data.processed) {
                    return new StripeIntentData(response.data.clientSecret);
                } else {
                    return new StripeIntentData(undefined, response.data.message);
                }
            }
        }
        return new StripeIntentData(undefined, app.payment.config.messages.paymentConfigErrorMessage);
    }

    public static makePaymentIntentRequest = async (app: any, amountToPay: any) => {
        let uri = "/api/webapp/stripe/paymentIntent";
        let data = {
            amount: parseFloat(amountToPay),
            currency: app.payment.config.currency,
            appId: app.id
        };

        try {
            return await axios.post(uri, data);
        } catch {
            return null;
        }
    };


}
